<template>
  <q-layout
    view="hHh lpr fFf"
    bordered
    class="shadow-2 rounded-borders vonix-phone-classes"
  >
    <q-header class="webTitleBar tw-bg-primary row justify-center items-center">
      <div class="tw-flex tw-items-center tw-justify-center tw-rounded-full tw-bg-white tw-py-[2px] tw-shadow-sm">
        <VonixLogo class="titlebar-logo" />
      </div>
    </q-header>

    <q-page-container>
      <q-page
        class="vonix-font tw-bg-[#F7FAFC]"
        :style-fn="myTweak"
      >
        <router-view />
        <InnerOffer />
      </q-page>
    </q-page-container>

    <audio
      id="remoteAudio"
      style="display: none"
    />
  </q-layout>
</template>

<script>
import InnerOffer from './InnerOffer'
import VonixLogo from '@/assets/icons/vonixLogo.svg'
const systemPreferences = window.systemPreferences

export default {
  components: {
    InnerOffer,
    VonixLogo
  },

  mounted () {
    this.$store.dispatch('connectionModule/startListeners', null, { root: true })
    this.askPermissions()
  },

  methods: {
    myTweak (offset) {
      return {
        width: '100%',
        height: `calc(100vh - ${offset}px)`,
        maxHeight: `calc(100vh - ${offset}px)`
      }
    },

    async askPermissions () {
      if (systemPreferences) await systemPreferences.askForMediaAccess('microphone')
      Notification.requestPermission()
    }
  }
}
</script>

<style lang="sass">
body,
.q-layout,
.q-layout .q-header,
.q-layout .q-page
  min-width: 430px

body
  background: #F7FAFC

.webTitleBar
  height: 36px
  border-bottom: 1px solid #0A4076

.titlebar-logo
  width: 19px
  height: 24px
  margin: 0 16px

.vonix-font
  font-family: Roboto
  font-style: normal
  display: flex
  color: #01253C

body::-webkit-scrollbar
  width: 0px

</style>
